import { putRequest, trustedRequest } from 'utils/request';

export const getBrands = () => trustedRequest('/api/vin-check/brands');
export const getModels = (brand: string) => trustedRequest(`/api/vin-check/models?brand=${brand}`);
export const vinCheck = putRequest('/api/vin-check');
export const getCommonProducts = () => trustedRequest('/api/vin-check/products/common');
